import React from 'react';
import ReactGA from 'react-ga';
import ReactMarkdown from 'react-markdown/with-html';

import text1 from './MMSIntegrationText1.js';
import text2 from './MMSIntegrationText2.js';
import BENEFIT_1 from './API_Icon_MMS_Benefit_1.png';
import BENEFIT_2 from './API_Icon_MMS_Benefit_2.png';
import BENEFIT_3 from './API_Icon_MMS_Benefit_3.png';
import BENEFIT_4 from './API_Icon_MMS_Benefit_4.png';

import './mmsIntegration.scss'

class MMSIntegrationComponent extends React.Component {
    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'MMS Integrations Guides Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        return <div className='mms-component'>
            <ReactMarkdown escapeHtml={false} children={text1} />
            <div className='key-benefits'>
                <div className='box'><img src={BENEFIT_1} alt='benefit_1' /><br /><span className='alt'>Create</span> shadow account for new members</div>
                <div className='box'><img src={BENEFIT_3} alt='benefit_3' /><br /><span className='alt'>Delete</span> shadow account</div>
                <div className='box'><img src={BENEFIT_4} alt='benefit_4' /><br />Automatically <span className='alt'>sync</span> with MMS and keep member profile and workout information up to date.</div>
            </div>
            <ReactMarkdown escapeHtml={false} children={text2} />
        </div>
    }
}

export default MMSIntegrationComponent;



// WEBPACK FOOTER //
// ./src/components/guides/MMSIntegration/MMSIntegrationComponent.js